





























































import Vue from 'vue';

export default Vue.extend ({
	name: 'item',
	props: [ 'name', 'from', 'to' ],
	data () {
		return {};
	}
});



